import React, { FC } from "react";
import styled from "styled-components";

import { formatSnakeCaseOrCamelCase } from "@formant/core/common/formatSnakeCaseOrCamelCase";
import { primary, severityLevels } from "@formant/ui/component/common/Colors";
import { Typography } from "@formant/ui/component/common/Typography";

import { Help } from "../common/Help";

interface ILabelProps {
    value?: string;
    description?: string;
    isTitle?: boolean;
    invalid?: boolean;
    color?: string;
    link?: string;
    uppercase?: boolean;
}

export const Label: FC<ILabelProps> = props => {
    const { invalid, isTitle, color, uppercase } = props;

    const renderColor = () => {
        if (color) {
            return color;
        }
        if (invalid) {
            return severityLevels.red;
        }
        if (isTitle) {
            return primary.silver;
        }
        return primary.white;
    };

    return (
        <LabelContainer className={props.invalid ? "invalid" : ""}>
            <Heading
                uppercase={uppercase}
                type={props.isTitle ? "h3" : "list"}
                color={renderColor()}
            >
                {formatSnakeCaseOrCamelCase(props.value || "")}
            </Heading>
            {props.description && (
                <Help
                    text={props.description}
                    size="18"
                    color={props.invalid ? severityLevels.red : undefined}
                    to={props.link}
                />
            )}
        </LabelContainer>
    );
};

const LabelContainer = styled.p`
    width: 19.5rem;
    margin-top: 1.5rem;
    margin-bottom: 6px;
    display: flex;
    align-items: center;

    svg {
        margin-left: 0.3125rem;
        margin-bottom: 1px;
    }
`;

const Heading = styled(Typography)`
    margin-left: 0.375rem;
`;
